import apiService from '../apiService';

const AuthApi = {
  login: (credentials) => apiService.post('/auth/login', credentials),
  register: (data) => apiService.post('/auth/register', data),
  logout: () => {
    localStorage.removeItem('authToken'); // Remove token from localStorage
    localStorage.removeItem('user');
    window.location.href = "/login"; // Redirect to login page
  } //apiService.post('/auth/logout'),
  ,
  getProfile: () => apiService.get('/auth/profile'), // Fetch user profile
  getUsers: () => apiService.get('/auth/users'), // Fetch all users
  updateUser: (id, data) => apiService.put(`/auth/users/${id}`, data), // Update user
  deleteUser: (id) => apiService.delete(`/auth/users/${id}`), // Delete user
};

export default AuthApi;
